import { tns } from 'tiny-slider/src/tiny-slider';
import {
	shouldAutoplaySlider,
	wireTnsAutoplayToggle
} from '../util/slider-autoplay-toggle';

class MediaContentSlider {
	constructor(el) {
		this.el = el;
		this.root = this.el.closest('.block-media-content__slider-wrapper');
		const prevButton = this.root?.querySelector('.block-media-content__slider-prev');
		const nextButton = this.root?.querySelector('.block-media-content__slider-next');
		const navContainer = this.root?.querySelector('.block-media-content__slider-nav');
		const autoplayToggle = this.root?.querySelector('[data-slider-autoplay-toggle]');
		const hasMultipleSlides = this.el.children.length > 1;
		const autoplayEnabled = hasMultipleSlides && shouldAutoplaySlider();

		const mediaContentSlider = tns({
			container: this.el,
			autoplay: autoplayEnabled,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: hasMultipleSlides,
			prevButton,
			nextButton,
			nav: hasMultipleSlides,
			navPosition: 'bottom',
			navContainer
		});

		prevButton?.removeAttribute('tabindex');
		nextButton?.removeAttribute('tabindex');

		const updateSlideFocus = () => {
			this.el.querySelectorAll('.tns-item').forEach((slide) => {
				slide.inert = slide.getAttribute('aria-hidden') === 'true';
			});
		};

		updateSlideFocus();
		mediaContentSlider.events.on('transitionEnd', updateSlideFocus);

		const updateLiveRegion = () => {
			const sliderInfo = mediaContentSlider.getInfo();
			const liveRegion = sliderInfo.container
				.closest('.tns-outer')
				.querySelector('.tns-liveregion');
			const currentSlide = ((sliderInfo.displayIndex - 1) % sliderInfo.slideCount) + 1;

			liveRegion.textContent = `Slide ${currentSlide} of ${sliderInfo.slideCount}`;
		};

		updateLiveRegion();
		mediaContentSlider.events.on('indexChanged', updateLiveRegion);

		if (hasMultipleSlides) {
			wireTnsAutoplayToggle(mediaContentSlider, autoplayToggle);
		}

		return mediaContentSlider;
		
	}
}

export default MediaContentSlider;
